import cx from 'classnames'

import CTA from '@f/elements/CTA/CTA'
import Icon from '@f/elements/Icon/Icon'

import { MenuItemType } from '../PageHeaderSSR'

interface SiteSearchFallbackProps {
  currentActiveMenu: MenuItemType | null
  isResultsPage: boolean
}

export const SiteSearchFallback = ({
  isResultsPage,
  currentActiveMenu
}: SiteSearchFallbackProps) => {
  return (
    <CTA
      type='icon'
      className={cx(
        '[ f-p-a-010 f-m-v-010 ]',
        'PageHeader-button PageHeader-with-submenu',
        currentActiveMenu === 'search' || (isResultsPage && 'is-open')
      )}
      onClick={() => {}}
      data-sel='btn-srch-ic'
      wtData={{
        'CTA-click': {
          label: 'search-start',
          location: 'header'
        }
      }}>
      <Icon
        icon='search-16px'
        className={cx(
          isResultsPage && 'is-open',
          'f-c-st-whi PageHeader-button-icon'
        )}
      />
      <span className='[ f-hidden:s f-hidden:m f-c-st-inherit ] PageHeader-button-label'>
        Suchen
      </span>
    </CTA>
  )
}
